/**
 * @Description 回到商圈重心位置
 */
import { FC } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';

const BackCore: FC<any> = ({
  setIsBack
}) => {

  return (
    <div
      className={styles.backCoreCon}
      onClick={() => setIsBack(true)}
    >
      <IconFont iconHref='iconic_mendiangengzhong'/>
    </div>
  );
};

export default BackCore;
